import {NavigationPathKey, TranslationKey} from '@enums'
import {SearchTableWrapper} from '@wrappers'

import React from 'react'

import {UIKit} from '@components'

import {useCompanySearchModel} from './company-search-model'

/**
 * Company Search page
 */
export function CompanySearchPage() {
  const {navigate, t, showCreateButton, rows, columns} = useCompanySearchModel()

  return (
    <SearchTableWrapper>
      <UIKit.Table
        {...(showCreateButton && {
          buttonProps: {
            buttonText: t(TranslationKey['Add new company']),
            onClick: () => navigate(NavigationPathKey.COMPANY_CREATION),
          },
        })}
        columns={columns}
        rows={rows}
        title={t(TranslationKey['List of companies'])}
      />
    </SearchTableWrapper>
  )
}
